import type { Nft } from '@0xtorch/core'
import type { Erc1155Transfer } from '../../../types'
import type { Erc1155TokenTransfer } from '../../../types/erc1155'
import { createErc1155NftId } from '../../../utils'

type ParseToErc1155TokenTransferParameters = {
  chainId: number
  transfer: Erc1155Transfer
  nfts: Map<string, Nft>
}

export const parseToErc1155TokenTransfer = ({
  chainId,
  transfer,
  nfts,
}: ParseToErc1155TokenTransferParameters): Erc1155TokenTransfer => {
  const id = createErc1155NftId({
    chainId,
    address: transfer.address,
    tokenId: transfer.tokenId,
  })
  const nft = nfts.get(id)
  return {
    ...transfer,
    token: nft ?? {
      type: 'Nft',
      id,
      updatedAt: 0,
    },
  }
}
